import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

const ITEMS = [
    'Bullet 1+0',
    'Blitz 3+2',
    'Rapid 10+0',
    'Classical 30+20',
    'Puzzle Rush',
    'Nightly arenas',
    'Instant review',
    'Play a friend'
]

const MarqueeStrip: FC = (): ReactNode => {
    return (
        <div aria-hidden='true' className='relative overflow-hidden border-y border-white/5 bg-[#070714] py-5'>
            <div className='animate-neon-marquee flex w-max items-center'>
                {[0, 1].map(copy => (
                    <div key={copy} className='flex shrink-0 items-center'>
                        {ITEMS.map((item, index) => (
                            <span key={item} className='flex items-center'>
                                <span
                                    className={cn(
                                        'px-6 font-heading text-2xl font-semibold uppercase tracking-wider sm:text-3xl',
                                        index % 2 === 0 ? 'hollow-text-pink' : 'text-neon-cyan glow-text-cyan'
                                    )}
                                >
                                    {item}
                                </span>

                                <span className='size-1.5 rotate-45 bg-neon-violet shadow-[0_0_10px_#9b6bff]' />
                            </span>
                        ))}
                    </div>
                ))}
            </div>

            <div className='pointer-events-none absolute inset-y-0 left-0 w-24 bg-linear-to-r from-[#070714] to-transparent' />
            <div className='pointer-events-none absolute inset-y-0 right-0 w-24 bg-linear-to-l from-[#070714] to-transparent' />
        </div>
    )
}

export default MarqueeStrip
